import type { Venue } from '../../types/venue';

export const maryhillEstate: Venue = {
  id: 'maryhill-estate',
  name: 'Maryhill Estate',
  description: {
    en: `<p>Icon since 1918 – Resort since 2024 with service re-invented.</p>
    
    <p>Two Destinations with 163 rooms & 16 venues. 2 restaurants with sensational culinary journeys. Pool Club with 3 year-round heated pools and 1 that likes to keep it cool – naturally, lounge beds & fireplaces.</p>
    
    <p>For couples, families, friends, or the single well-traveled souls.</p>`,
    
    sv: `<p>En dagdröm som aldrig försvann, idag en levande verklighet. Sedan vår start av ESS Group 2007 har passionen för att skapa destinationer vuxit likt dragningskraften till just den här platsen. Vi har drömt länge om att ge den nytt liv och inte minst Örenäs Slott, en ny mening.</p>
    
    <p>Det är för oss ett ärofyllt kapitel som vi nu lyckats bläddra fram till. Varmt välkommen till en restaurerad ikon – Maryhill Estate. Du hittar oss 10 minuter norr om Landskrona, blott ett stenkast från Öresunds kust.</p>`,
    
    no: `<p>Ikon siden 1918 – Resort siden 2024 med nyskapende service.</p>
    
    <p>To destinasjoner med 163 rom og 16 lokaler. 2 restauranter med sensasjonelle kulinariske reiser. Pool Club med 3 helårs oppvarmede bassenger og 1 som liker å holde det kjølig – naturligvis, med loungesenger og peiser.</p>
    
    <p>For par, familier, venner eller de enslige velreiste sjeler.</p>`,
    
    da: `<p>Ikon siden 1918 – Resort siden 2024 med genopfundet service.</p>
    
    <p>To destinationer med 163 værelser og 16 lokaler. 2 restauranter med sensationelle kulinariske rejser. Pool Club med 3 helårs opvarmede pools og 1 der holder det køligt – naturligvis, loungesenge og pejse.</p>
    
    <p>For par, familier, venner eller de enlige velrejste sjæle.</p>`
  },
  image: '/assets/images/maryhill.jpg',
  country: 'se',
  region: 'skåne',
  city: 'Malmo',
  address: 'Stortorget 12, 211 34 Malmö, Sweden',
  coordinates: {
    lat: 55.94074977003541,
    lng: 12.778716824762338
  },
  capacity: {
    min: 10,
    max: 300
  },
  rating: 4.9,
  reviews: Array.from({ length: 180 }, (_, i) => ({
    id: `review-${i}`,
    userId: `user-${i}`,
    rating: 4.9,
    comment: '',
    date: new Date().toISOString()
  })),
  amenities: ['wifi', 'coffee', 'restaurant', 'pool', 'spa'],
  images: [
    '/assets/images/maryhill.jpg',
    'https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&q=80&w=2000'
  ],
  priceRange: {
    min: 2800,
    max: 35000
  },
  recommended: false,
  factbox: {
    rooms: 163,
    conferenceRooms: 16,
    meetingCapacity: 300,
    features: [
      'Icon since 1918 – Resort since 2024',
      '163 rooms',
      '16 meeting venues',
      '2 restaurants with sensational culinary journeys',
      'Pool Club with 3 year-round heated pools',
      '1 naturally cooled pool',
      'Lounge beds & fireplaces',
      'Located 10 minutes north of Landskrona',
      'Near the coast of Öresund',
      'Historic property with modern amenities',
      'Suitable for couples, families, friends, or solo travelers'
    ]
  }
}; 